import Membership from "./Membership.js";
import UZod from "@repo/utils/UZod";
import Organization from "./Organization.js";
import UObject from "@repo/utils/UObject";
import User from "./User.js";

type Customer = UObject.Override<
  User,
  {
    id: Customer.Id;
    classVoucherWallet: Customer.ClassVoucherWallet;
    guestPassWallet: Customer.GuestPassWallet;
    createdAt: Date;
    organizationId: Organization.Id;
  }
>;

namespace Customer {
  export type Id = `cu_${string}`;

  export type Params = Pick<Customer, "email" | "name" | "phone">;

  export type ClassVoucherWallet = {
    id: ClassVoucherWallet.Id;
    count: number;
    unlimitedMembershipId?: Membership.Id;
  };
  export namespace ClassVoucherWallet {
    export type Id = `cvw_${string}`;
  }
  export type GuestPassWallet = {
    id: GuestPassWallet.Id;
    count: number;
    unlimitedMembershipId?: Membership.Id;
  };
  export namespace GuestPassWallet {
    export type Id = `gpw_${string}`;
  }

  export type Group = {
    id: Group.Id;
    query: Group.Query;
    parameterizedSqlSnapshot: string;
    params: Record<string, string>;
  };
  export namespace Group {
    // Backend calls this DetailedCustomerGroup
    export type Id = `dcg_${string}`;
    export type Query = {
      id: Query.Id;
      name: string;
      parameterizedSql: Query.ParameterizedSql;
    };
    export namespace Query {
      export type Id = `cg_${string}`;
      export namespace Id {
        export const is = (id: string | undefined): id is Id =>
          !!id?.startsWith("cg_");
        export const zodSchema = (message = "Invalid group id") =>
          UZod.predicate(is, message);
      }

      export const sqlParams = (query: Query) =>
        ParameterizedSql.parseParams(query.parameterizedSql);

      export type ParameterizedSql = string & {
        [ParameterizedSql.symbol]: true;
      };
      export namespace ParameterizedSql {
        export declare const symbol: unique symbol;
        export const parseParams = (parameterizedSql: ParameterizedSql) =>
          Object.fromEntries(
            [
              ...parameterizedSql.matchAll(/(\w+\.public_id).+?\{\{(.*?)\}\}/g),
            ].map(([, record, name]) => [name, record]),
          );
      }
    }
  }
}

export default Customer;
